module.exports = __webpack_public_path__ + "img/2.4d7f10f3.webp";